(function () {
  'use strict';

  angular
    .module('seniorityList')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('seniorityList', {
        url: '/seniority-list',
        views : {
          'seniorityListView' : {
            templateUrl: 'seniority-list/views/seniority-list.tpl.html',
            controller: 'SeniorityListCtrl',
            controllerAs: 'seniorityList'
          }
        }
      });
  }
}());
